// i18nOwl-ignore [app-spotify.medias.playlist.title]
import MediaContentSpotifyPlaylist from '@cohort/components-xps/components/contents/apps/spotify/playlist/MediaContentSpotifyPlaylist';
import type {ContentMedia} from '@cohort/merchants/apps';
import SpotifyPlaylistMediaConfigComponent from '@cohort/merchants/apps/spotify/medias/playlist/ConfigComponent';
import SpotifyPlaylistVisualPreview from '@cohort/merchants/apps/spotify/medias/playlist/VisualPreview';
import type {SpotifyPlaylistMediaStruct} from '@cohort/shared/apps/spotify/medias/playlist';
import {SpotifyPlaylistMediaSpec} from '@cohort/shared/apps/spotify/medias/playlist';
import {SvgAppIcon} from '@cohort/shared-frontend/common/AppIcons';

export const SpotifyPlaylistMedia: ContentMedia<SpotifyPlaylistMediaStruct> = {
  spec: SpotifyPlaylistMediaSpec,
  configComponent: SpotifyPlaylistMediaConfigComponent,
  getTitle: t => t('medias.playlist.title', {ns: 'app-spotify'}),
  mediaContent: MediaContentSpotifyPlaylist,
  icon: ({size}) => <SvgAppIcon name="spotify" height={size} width={size} />,
  visualPreview: SpotifyPlaylistVisualPreview,
};
